import React, { PureComponent } from 'react';
import { Line } from 'react-chartjs-2';

const getRightData = (rawInput, label, countlist, rawInput2, label2, countlist2) => {
  const data = {
    labels: rawInput.labels,
    datasets: [
      {
        label: label,
        fill: true,
        lineTension: 0.1,
        backgroundColor: 'rgba(40, 167, 69, 0.3)',
        borderColor: 'rgba(40, 167, 69, 1)',
        borderCapStyle: 'butt',
        pointBorderColor: 'rgba(40, 167, 69, 1)',
        pointBackgroundColor: 'rgba(40, 167, 69, 1)',
        pointBorderWidth: 1,
        pointHoverRadius: 8,
        pointHoverBackgroundColor: 'rgba(40, 167, 69, 1)',
        pointHoverBorderColor: 'rgba(40, 167, 69, 1)',
        pointHoverBorderWidth: 8,
        pointRadius: 1,
        pointHitRadius: 10,
        data: rawInput.datasets,
        yAxisID: 'y-axis-1'
      },
      {
        label: 'Bài Viết',
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(220, 53, 69, 1)',
        borderColor: 'rgba(220, 53, 69, 1)',
        yAxisID: 'y-axis-2',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(220, 53, 69, 1)',
        pointBackgroundColor: 'rgba(220, 53, 69, 1)',
        pointBorderWidth: 5,
        pointHoverRadius: 8,
        pointHoverBackgroundColor: 'rgba(220, 53, 69, 1)',
        pointHoverBorderColor: 'rgba(220, 53, 69, 1)',
        pointHoverBorderWidth: 8,
        pointRadius: 1,
        pointHitRadius: 10,
        data: countlist
      },
    ]
  };

  return data;
}
export default class ChartLine extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataPageviews: {
        labels: [],
        datasets: []
      },
      dataFBPageviews: {
        labels: [],
        datasets: []
      },
      dataSessions: {
        labels: [],
        datasets: []
      },
      dataFBSessions: {
        labels: [],
        datasets: []
      },
      countlist:{},
      countFBList:{}
    }
  }

  formatNumber(num) {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return num_parts.join(",");
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { report: nextReport, reportFB: nextFBReport } = nextProps;
    if (nextReport && nextFBReport) {
      let report = nextReport;
      let reportFB = nextFBReport;
      const dataPageviews = {
        labels: [],
        datasets: []
      };
      const dataFBPageviews = {
        labels: [],
        datasets: []
      };
      const dataSessions = {
        labels: [],
        datasets: []
      };
      const dataFBSessions = {
        labels: [],
        datasets: []
      };
      // UA
      if(report.data){
        report.data.rows.forEach(row => {
          dataSessions.labels.push(row.dimensions);
          dataSessions.datasets.push(row.metrics[0].values[0]);
        });
        
        
  
        report.data.rows.forEach(row => {
          dataPageviews.labels.push(row.dimensions);
          dataPageviews.datasets.push(row.metrics[0].values[1]);
        });
  
        if(reportFB.data.rows){
          reportFB.data.rows.forEach(row => {
            dataFBSessions.labels.push(row.dimensions);
            dataFBSessions.datasets.push(row.metrics[0].values[0]);
          });
  
          reportFB.data.rows.forEach(row => {
            dataFBPageviews.labels.push(row.dimensions);
            dataFBPageviews.datasets.push(row.metrics[0].values[1]);
          });
        }
        else{
          report.data.rows.forEach(row => {
            dataFBPageviews.labels.push(row.dimensions);
            dataFBPageviews.datasets.push(0);
            dataFBSessions.labels.push(row.dimensions);
            dataFBSessions.datasets.push(0);
          });
        }
  
        this.setState({
          dataSessions,
          dataPageviews,
          dataFBSessions,
          dataFBPageviews
        });
      }

      // GA v4
      if(report.rows && report.rows.length > 0){
        report.rows.forEach(row => {
          dataSessions.labels.push(row.dimensionValues[0].value);
          dataSessions.datasets.push(row.metricValues[0].value);
        });
        
        
  
        report.rows.forEach(row => {
          dataPageviews.labels.push(row.dimensionValues[0].value);
          dataPageviews.datasets.push(row.metricValues[1].value);
        });
  
        if(reportFB.rows && reportFB.rows.length > 0){
          reportFB.rows.forEach(row => {
            dataFBSessions.labels.push(row.dimensionValues[0].value);
            dataFBSessions.datasets.push(row.metricValues[0].value);
          });
  
          reportFB.rows.forEach(row => {
            dataFBPageviews.labels.push(row.dimensionValues[0].value);
            dataFBPageviews.datasets.push(row.metricValues[0].value);
          });
        }
        else{
          report.rows.forEach(row => {
            dataFBPageviews.labels.push(row.dimensionValues[0].value);
            dataFBPageviews.datasets.push(0);
            dataFBSessions.labels.push(row.dimensionValues[0].value);
            dataFBSessions.datasets.push(0);
          });
        }
  
        this.setState({
          dataSessions,
          dataPageviews,
          dataFBSessions,
          dataFBPageviews
        });
      }

    }
  }

  render() {
    const { dataPageviews, dataSessions, dataFBSessions, dataFBPageviews } = this.state;
    const { type } = this.props;
    let data = {};
    if (type === 'pageviews') {
      data = getRightData(dataPageviews,'Pageviews', this.props.countlist, dataFBPageviews, 'Pageviews IA', this.props.countFBList);
    } else if (type === 'sessions') {
      data = getRightData(dataSessions, 'Sessions', this.props.countlist, dataFBSessions, 'Sessions IA', this.props.countFBList);
    }

    return (
      <Line
        data={data}
        height={300}
        options={
          {
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  type: 'linear',
                  display: true,
                  position: 'left',
                  id: 'y-axis-1',
                  ticks: {
                    callback: function (label, index, labels) {
                      return label / 1000 + 'k';
                    }
                  }
                },
                {
                  type: 'linear',
                  display: true,
                  position: 'right',
                  id: 'y-axis-2',
                }
              ],
              xAxes: [
                {
                  ticks: {
                    callback: function (label, index, labels) {
                      if(Array.isArray(label)){
                        return label[0].slice(-2);
                      }
                      else{
                        return label.slice(-2);
                      }
                    }
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Ngày'
                  }
                }
              ]
            }
          }
        }
      />

    );
  }
} 